import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@src/store";

import { ITabState } from "./types";

const initialState: ITabState = {};

const tabSlice = createSlice({
  name: "tab",
  initialState,
  reducers: {
    setTabIndex: (
      state,
      action: PayloadAction<{
        id: string;
        tabIndex?: number;
      }>
    ) => {
      const { id, tabIndex } = action.payload;
      if (tabIndex !== undefined) {
        state[id] = tabIndex;
      } else {
        delete state[id];
      }
    },
  },
});

export const tabReducer = tabSlice.reducer;
export const { setTabIndex } = tabSlice.actions;

export const getTabIndex = (id: string) => (state: RootState) => state.tab[id];
